import { render, staticRenderFns } from "./Adminstraion.vue?vue&type=template&id=24ca7c54&scoped=true"
import script from "./Adminstraion.vue?vue&type=script&lang=js"
export * from "./Adminstraion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca7c54",
  null
  
)

export default component.exports